import { render, staticRenderFns } from "./StormCauseTypeQuestion.vue?vue&type=template&id=1ea0d3e0&scoped=true"
import script from "./StormCauseTypeQuestion.vue?vue&type=script&lang=ts"
export * from "./StormCauseTypeQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea0d3e0",
  null
  
)

export default component.exports